import React from 'react'
import { EnvironmentTitle, HeroPanel } from 'view/shared/heroPanel'
import { WindowActions } from 'epics/windowEpic'
import { Locale, Translation } from 'locale'
import { useDispatch } from 'react-redux'

export const PrimeBrokerDefaultsHeroPanel = () => {
  const dispatch = useDispatch()
  const onTearout = () => dispatch(WindowActions.tearoutGrid('/quote/tearout/primeBrokerDefaults'))

  return (
    <HeroPanel onTearout={onTearout}>
      <EnvironmentTitle data-test-id={'PrimeBrokerDefaultsHeroPanel-EnvironmentTitle'}>
        {Locale.translate(Translation.TC_HERO_PRIME_BROKER_DEFAULTS)}
      </EnvironmentTitle>
    </HeroPanel>
  )
}
